import React from 'react';
import {
  BarChart,
  Bar,
  PieChart,
  Pie,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';

// Bar Chart Component
export const CustomBarChart = ({ data, colors = ['#E45858'], height = 300, customTooltip }) => {
  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart data={data} margin={{ top: 10, right: 10, left: 10, bottom: 10 }}>
        <CartesianGrid strokeDasharray="3 3" vertical={false} />
        <XAxis 
          dataKey="name"
          tick={{ fill: '#545454', fontSize: 12 }}
          axisLine={false}
          tickLine={false}
          interval={0}
          angle={-45}
          textAnchor="end"
          height={60}
        />
        <YAxis 
          tick={{ fill: '#545454', fontSize: 12 }}
          axisLine={false}
          tickLine={false}
          allowDecimals={false}
        />
        {customTooltip ? (
          <Tooltip content={customTooltip} cursor={{ fill: 'transparent' }} />
        ) : (
          <Tooltip
            contentStyle={{
              backgroundColor: '#1A1A1A',
              border: 'none',
              borderRadius: '4px',
              color: '#fff'
            }}
            cursor={{ fill: 'transparent' }}
          />
        )}
        <Bar 
          dataKey="value" 
          fill={colors[0]}
          radius={[4, 4, 0, 0]}
          barSize={20}
          minPointSize={3}
        />
      </BarChart>
    </ResponsiveContainer>
  );
};

// Pie Chart Component
export const CustomPieChart = ({ data, colors = ['#E45858'], height = 300, customTooltip }) => {
  return (
    <ResponsiveContainer width="100%" height={height}>
      <PieChart>
        <Pie
          data={data}
          cx="50%"
          cy="50%"
          innerRadius={60}
          outerRadius={80}
          paddingAngle={5}
          dataKey="value"
        >
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
          ))}
        </Pie>
        {customTooltip ? (
          <Tooltip content={customTooltip} />
        ) : (
          <Tooltip
            contentStyle={{
              backgroundColor: '#1A1A1A',
              border: 'none',
              borderRadius: '4px',
              color: '#fff'
            }}
          />
        )}
        <Legend />
      </PieChart>
    </ResponsiveContainer>
  );
};
